module.exports = __webpack_public_path__ + "media/images/mobile-only/element08-70a287630adff5ca9f6cc8d8d0bd459b.png";